import * as React from "react";
import { Title1, Text, Title3, Link } from "@fluentui/react-components";

export const Imprint = React.memo(() => (
    <div>
        <Title1>
            Imprint
        </Title1>

        <br />
        <br />
        
        <Title3>
            According to § 5 of the German Telemedia Act (TMG)
        </Title3>

        <p>
            <Text>
                Florian Krönert&nbsp; <br />
                Ianua Software UG (haftungsbeschränkt)&nbsp; <br />
                Bogenweilerstraße 40&nbsp; <br />
                88348 Bad Saulgau
            </Text>
        </p>

        <Title3>Contact</Title3>
        
        <p>
            <Text>
                Phone: +49 (0) 175 8827205&nbsp; <br />
                E-Mail: contact(at)ianuasoftware.com
            </Text>
        </p>

        <h3>VAT ID</h3>
        <p>VAT tax identification number according to § 27 VAT Act:&nbsp; <br />DE455801666</p>

        <Title3>Responsibility of content</Title3>

        <p>
            <Text>
                Florian Krönert&nbsp; <br />
                Bogenweilerstraße 40&nbsp; <br />
                88348 Bad Saulgau
            </Text>
        </p>

        <Title3>EU Dispute Settlement</Title3>
        <p>
            <Text>
                The European Commission provides a platform for online dispute resolution (OS): <Link href="https://ec.europa.eu/consumers/odr/">https://ec.europa.eu/consumers/odr/</Link>.
                <br />
                Our e-mail address can be found above in the imprint.
            </Text>
        </p>

        <Title3>Consumer dispute resolution/universal arbitration board</Title3>
        <p>
            <Text>
                We are not willing or obliged to participate in any dispute resolution procedure participate in the consumer arbitration board.
            </Text>
        </p>

        <Title3>Liability for content</Title3>
        <p>
            <Text>
                As a service provider, we are responsible for our own content on these pages according to Section 7, Paragraph 1 of the German Telemedia Act (TMG).
                <br />
                According to §§ 8 to 10 TMG, however, we as a service provider are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.
                <br />
                <br />
                Obligations to remove or block the use of information according to general laws remain unaffected. However, liability in this regard is only possible from the point in time at which knowledge of a specific infringement of the law is known.
                <br />
                As soon as we become aware of any violations of the law, we will remove this content immediately.
            </Text>
        </p>

        <Title3>Liability for links</Title3>
        <p>
            <Text>
                Our offer contains links to external websites over which we have no influence. Therefore we cannot assume any liability for this external content.
                <br />
                The respective provider or operator of the pages is always responsible for the content of the linked pages.
                <br />
                The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking.
                <br />
                <br />
                However, a permanent control of the content of the linked pages is not reasonable without concrete evidence of an infringement.
                <br />
                As soon as we become aware of legal violations, we will remove such links immediately.
            </Text>
        </p>

        <Title3>Copyright</Title3>
        <p>
            <Text>
                The content and works on these pages created by the site operators are subject to German copyright law. The duplication, editing, distribution and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator.
                <br />
                Downloads and copies of this site are only permitted for private, non-commercial use.
                <br />
                <br />
                Insofar as the content on this site was not created by the operator, the copyrights of third parties are observed.
                <br />
                In particular contents of third parties are marked as such. Should you nevertheless become aware of a copyright infringement, we ask that you inform us accordingly.
                <br />
                As soon as we become aware of legal violations, we will remove such content immediately.
            </Text>
        </p>
        <p>
            <Text>
                Source: <Link href="https://www.e-recht24.de">e-recht24.de</Link>
            </Text>
        </p>
    </div>
));